import { Component } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"
import EndpointTestCaseItem from "partners/components/endpoint_test/test_case_item"

export default class EndpointTestCases extends Component {
  render() {
    let testCases = _map(this.props.endpoint.test_cases, (testCase, slug) => (
      <EndpointTestCaseItem
        endpoint={this.props.endpoint}
        testCase={testCase}
        testCaseStatus={this.props.testCaseStatus}
        toggleTestCase={this.props.toggleTestCase}
        key={testCase.dom_id}
        slug={slug}
      />
    ))
    return <div className="test-cases">{testCases}</div>
  }
}

EndpointTestCases.propTypes = {
  endpoint: PropTypes.object.isRequired,
  testCaseStatus: PropTypes.func.isRequired,
  toggleTestCase: PropTypes.func.isRequired,
}
